export var gcd = function gcd(a, b) {
  return b ? gcd(b, a % b) : a;
};

var aspectRatio = function aspectRatio(width, height) {
  var divisor = gcd(width, height);

  return width / divisor + ":" + height / divisor;
};

export default aspectRatio;